import React, { PureComponent } from 'react'
import { View, TouchableOpacity } from 'react-native'
import { createContainer } from '@dbk-legacy/muster/react'
import Text from '@dbk/ui-text'
import Modal from '@dbk/ui-modal'
import { QuestionMark } from '../../../../components/common/icons'

class PymtReason extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      pymtReasonModalVisible: false,
    }

    this.handleIconPress = this.handleIconPress.bind(this)
    this.handleDone = this.handleDone.bind(this)
  }

  handleIconPress() {
    this.setState({
      pymtReasonModalVisible: true,
    })
  }

  handleDone() {
    this.setState({
      pymtReasonModalVisible: false,
    })
    this.forceUpdate()
  }

  render() {
    const {
      i18n: { messages },
    } = this.props
    const { pymtReasonModalVisible } = this.state

    return (
      <View style={{ alignSelf: 'flex-end', position: 'relative', bottom: 5 }}>
        <TouchableOpacity onPress={this.handleIconPress}>
          <div style={{marginLeft: 10}} aria-label={messages['app.orderReport.infoIcon']}>
            <QuestionMark width={18} height={18} color={'#ffffff'} />
          </div>
        </TouchableOpacity>
        <View>
          <Modal
            isActive={pymtReasonModalVisible}
            onClose={this.handleDone}
            header={<Text secondary tabIndex={0}>{messages['app.payment.reason.modal.header']}</Text>}
            content={
              <div className='modal__header' style={{border: 'none', backgroundColor: 'inherit'}} tabIndex={0}>
                {messages['app.payment.reason.modal.content']}
              </div>
            }
          />
        </View>
      </View>
    )
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
  },
})(PymtReason)
